import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'muffler-config',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./MufflerConfig').default
      callback(null, component)
    }, 'MufflerConfig')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/MufflerConfig/index.js